import React, { Component } from 'react';
import { connect } from 'react-redux';

import {startTrip} from '../../state/actions/timeline';

import './Splash.scss';

import Icons from '../Shared/Icons';

class Splash extends Component {

    render() {
        if (this.props.tripStarted) return null;

        const {video} = this.props;

        return (
            <div className="Splash">
                <div className="Splash__logo">
                    <Icons type="logo-big" />
                </div>
                <div className="Splash__spacer Splash__spacer--logo"></div>
                <p className="Splash__excerpt">
                    {video.introText}
                </p>
                <div className="Splash__spacer Splash__spacer--button"></div>
                <div onClick={this.startTrip.bind(this)} className="Splash__button">{video.startRoute}</div>
            </div>
        );
    }

    startTrip() {
        this.goFullScreen();
        this.props.startTrip();
    }

    goFullScreen() {
        if (window.chrome && /Android/.test(navigator.userAgent) && !document.webkitFullScreen) {
            document.body.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        }
    }

}

function mapStateToProps({timeline, video}) {
    return {
        video,
        tripStarted: timeline.tripStarted
    }
}

export default connect(mapStateToProps, {startTrip})(Splash);


// WEBPACK FOOTER //
// ./src/components/Splash/index.js